import { render, staticRenderFns } from "./searchresults.vue?vue&type=template&id=7ece3989&scoped=true"
import script from "./searchresults.vue?vue&type=script&lang=js"
export * from "./searchresults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece3989",
  null
  
)

export default component.exports